module.exports = __webpack_public_path__ + "static/media/wizualizacja-109.8dc73723.png";